module.exports = __webpack_public_path__ + "plane-twilight.f2f91c06d6b1bcb15093.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/plane-twilight.svg
// module id = ../../../../../src/assets/img/plane-twilight.svg
// module chunks = main